module.exports = fox._r("images/press/icon-name.png", __webpack_public_path__ + "_/common/images/press/icon-name.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-name.png
// module id = 376
// module chunks = 2